import {config as numberColumnConfig} from '../../common/NumberColumn';

const prop = 'rAUnAsgn';
export const id = 'reviewerNotAssigned';

export const config = (labels) => numberColumnConfig({fullId: id, label: labels.reviewerNotAssigned, prop});
